<div class="relative z-20"
     role="dialog"
     aria-modal="true"
     [attr.aria-hidden]="!visible"
     [attr.inert]="!visible ? '' : null">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-in-out duration-500"
         [ngClass]="visible ? 'visible opacity-100' : 'invisible opacity-0'"></div>

    <div class="fixed inset-0 overflow-hidden overlay-container" [ngClass]="visible ? 'visible' : 'invisible'">
        <div class="absolute inset-0 overflow-hidden" (click)="overlayClick($event)" #overlay>
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                <div class="pointer-events-auto w-screen max-w-md transform transition ease-in-out duration-300 translate-x-full"
                    [class.translate-x-0]="visible"
                    [class.translate-x-full]="!visible"
                >
                    <div class="flex h-full flex-col bg-white shadow-xl">
                        <div class="flex-1 height-full flex flex-col overflow-y-hidden py-6 px-4 sm:px-6">
                            <div class="flex items-center justify-between px-4">
                                <p class="text-lg font-medium text-gray-900">Shopping Cart</p>
                                <button class="btn" (click)="close.emit()">
                                    <fa-icon icon="times" class="text-gray-400"></fa-icon>
                                </button>
                            </div>
                            <div *ngIf="!(isEmpty$ | async); else empty" class="mt-8 px-4 overflow-y-auto">
                                <vsf-cart-contents [cart]="cart$ | async"
                                                   [canAdjustQuantities]="true"
                                                   (setQuantity)="setQuantity($event)"></vsf-cart-contents>

                            </div>

                            <ng-template #empty>
                                <div class="flex items-center justify-center h-48 text-xl text-gray-400">
                                    Your cart is empty
                                </div>
                            </ng-template>
                        </div>
                        <div class="border-t border-gray-200 py-6 px-4 sm:px-6" *ngIf="!(isEmpty$ | async)">
                            <div *ngIf="cart$ | async as cart">
                                <div *ngIf="cart.discounts && cart.discounts.length > 0" class="applied-coupon">
                                    <p class="text-base font-medium">Your Discounts</p>
                                    <div *ngFor="let discount of cart.discounts" class="flex justify-between text-sm text-gray-900">
                                        <p>{{ discount.description }}</p>
                                        <p>{{ discount.amount | formatPrice }}</p>
                                    </div>
                                </div>
                                <div class="flex justify-between text-base font-medium text-gray-900">
                                    <p class="font-bold">Subtotal</p>
                                    <p>
                                        {{ cart.subTotal | formatPrice }}
                                    </p>
                                </div>
                                <p class="mt-0.5 text-sm text-gray-500">
                                    Shipping, Tax and Promo will be applied during
                                    checkout.
                                </p>
                                <div class="mt-6">
                                    <button (click)="continueToCheckout()"
                                            class="btn-primary flex w-full">
                                        Checkout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
